import * as nextHandler from "./NextHandler"
import * as jhsFreeAction from "../../model/action/JhsFreeAction"
import * as baseNavigationGuard from "./BaseNavigationGuard";
import {isLogin} from "./BaseNavigationGuard";
import * as init from "./Init";
import {SchoolGradeUtil} from "../../util/SchoolGradeUtil";

export let getStoreData = () => {
    const store = init.getStore();
    return {
        accountStatus: store.getters['AccountStoreV2/accountStatus'],
        familyName: store.getters['JhsFreeStore/familyName'],
        givenName: store.getters['JhsFreeStore/givenName'],
        birthYear: store.getters['JhsFreeStore/birthYear'],
        birthMonth: store.getters['JhsFreeStore/birthMonth'],
        birthDay: store.getters['JhsFreeStore/birthDay'],
        grade: store.getters['JhsFreeStore/grade'],
        mailAddress: store.getters['JhsFreeStore/mailAddress'],
        fileCertificateSchoolIssuedFront: store.getters['JhsFreeStore/fileCertificateSchoolIssuedFront'],
        fileCertificateSchoolIssuedBack: store.getters['JhsFreeStore/fileCertificateSchoolIssuedBack'],
    }
};

/**
 * ログイン誘導画面のnavigation guard.
 * すでにログインしている場合はLPへリダイレクトさせる
 */
export function checkLoginStatus(next) {
    if(!isLogin()) {
        next()
    } else {
        nextHandler.nextReplace(next, '/lp')
    }
}

/**
 * 申込情報入力画面のnavigation guard
 * 申し込み開始時にログアウト状態だった場合はログイン誘導画面へ
 * 申込不可な場合は不可理由に合わせて各種エラー画面へリダイレクト
 */
export function checkAuditionAvailable(next) {
    if(isLogin()) {
        const storeData = baseNavigationGuard.getStoreData();
        const isRedPenaltyAccount = storeData.accountStatus.account.puriGetPenalty.isRed;
        if (isRedPenaltyAccount) {
            nextHandler.nextReplace(next, '/error/audition/penalty')
        } else {
            jhsFreeAction.getAuditionAvailable()
                .then(result => {
                    switch (result.data.code) {
                        case '000':
                            next()
                            break;
                        case '100':
                            nextHandler.nextReplace(next, '/error/audition/duplicated')
                            break;
                        case '200':
                            nextHandler.nextReplace(next, '/error/audition/denied')
                            break;
                        default:
                            nextHandler.nextReplace(next, '/lp')
                    }
                })
                .catch(() => {
                    nextHandler.nextReplace(next, '/lp')
                })
        }
    }else {
        nextHandler.nextReplace(next, '/guidance/login')
    }
}

/**
 * 本人確認書類画面のnavigation guard.
 * ログインしていない or storeにprofileの値がない or 生年月日と学年の組み合わせが間違っている場合はLPへ遷移させる
 */
export function checkCertificate(next) {
    if(isLogin() && hasProfile() && isMatchingGrade()) {
        next()
    } else {
        nextHandler.nextReplace(next, '/lp')
    }
}

/**
 * 最終確認画面/申込完了画面のnavigation guard.
 * ログインしていない or storeに申込情報と本人確認書類の値がない or 生年月日と学年の組み合わせが間違っている場合はLPへ遷移させる
 */
export function checkCompleteAll(next) {
    const storeData = getStoreData();
    const hasSchoolIssued = storeData.fileCertificateSchoolIssuedFront;

    if(isLogin() && hasProfile() && isMatchingGrade() && hasSchoolIssued) {
        next()
    } else {
        nextHandler.nextReplace(next, '/lp')
    }
}

/**
 * 申し込み情報入力ページで、正しい生年月日と学年の組み合わせで入力されているかの判定
 */
function isMatchingGrade() {
    const storeData = getStoreData();
    const accountStatus = storeData.accountStatus;
    const birthYear = storeData.birthYear;
    const birthMonth = storeData.birthMonth;
    const birthDay = storeData.birthDay;
    const grade = storeData.grade;

    // TimeTripが設定されている場合はその日付を使用する
    let now = accountStatus.timeTripDate.nowDateTime.toDate();
    return SchoolGradeUtil.isMatchingGrade(new Date(birthYear, birthMonth - 1, birthDay), now, grade);
}

/**
 * 申込情報入力ページで入力されるstoreデータを保持しているかの共通判定
 */
function hasProfile() {
    const storeData = getStoreData();
    const familyName = storeData.familyName;
    const givenName = storeData.givenName;
    const birthYear = storeData.birthYear;
    const birthMonth = storeData.birthMonth;
    const birthDay = storeData.birthDay;
    const grade = storeData.grade;
    const mailAddress = storeData.mailAddress;
    return !!(familyName && givenName && birthYear && birthMonth && birthDay && mailAddress && grade);
}
